import React from 'react';
import NavbarLanding from '../components/NavbarLanding';
import Footer from './Footer';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <NavbarLanding />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-2 text-center">
            Cookie Policy
          </h1>
          <p className="text-sm text-gray-500 mb-8 text-center">Last Updated: [Insert Date]</p>
          
          <div className="prose prose-lg max-w-none">
            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. What Are Cookies?</h2>
                <p className="text-gray-700">
                  Cookies are small text files placed on your device (computer, tablet, or phone) when you visit a website. They help us improve your browsing experience, remember your preferences, and analyze how our site is used.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. How We Use Cookies</h2>
                <p className="text-gray-700 mb-3">We use cookies for the following purposes:</p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li><span className="font-medium">Essential Cookies</span>: Needed for the website to function (e.g., login, security, shopping cart).</li>
                  <li><span className="font-medium">Performance &amp; Analytics Cookies</span>: Help us understand how visitors use our site (e.g., pages visited, time spent).</li>
                  <li><span className="font-medium">Functionality Cookies</span>: Remember your settings and preferences (e.g., language, region).</li>
                  <li><span className="font-medium">Advertising &amp; Marketing Cookies</span>: Deliver relevant ads and measure campaign performance.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Third-Party Cookies</h2>
                <p className="text-gray-700">
                  Some cookies are placed by trusted third parties, such as analytics providers (e.g., Google Analytics), advertising networks, and social media platforms. These third parties may collect information about your online activities across different websites.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Managing Cookies</h2>
                <p className="text-gray-700 mb-3">You can control and manage cookies in several ways:</p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Most browsers allow you to block or delete cookies through their settings.</li>
                  <li>You can opt out of certain third-party cookies through their respective platforms.</li>
                  <li>Please note that disabling cookies may affect the functionality of our website.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Updates to This Policy</h2>
                <p className="text-gray-700">
                  We may update this Cookie Policy from time to time to reflect changes in technology, law, or our practices. Updates will be posted on this page with a new “Last Updated” date.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Contact Us</h2>
                <p className="text-gray-700">
                  If you have questions about this Cookie Policy, please contact us at: [Insert Company Contact Email / Data Protection Officer Contact]
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default CookiePolicy;
